import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { submitLinkCta } from 'LiveBoard/modules/cta'
import { withOutboundLink } from 'LiveBoard/hocs'
import { LINK_TARGETS } from '../constants'

class OpenLinkContainer extends React.Component {
  componentDidMount() {
    const {
      area, config,  lead,
      submitLinkCta, onDone
    } = this.props

    if(config.metadata.url) {
      submitLinkCta({
        cta: {
          area,
          label: config.text
        },
        email: lead.email,
        type: config.type,
        link: config.metadata.url
      })
      this.props.onOpenOutboundLink(config.metadata.url, LINK_TARGETS[config.type])
    }

    onDone()
  }

  render = () => null
}

OpenLinkContainer.propTypes = {
  area: PropTypes.string.isRequired,
  config: PropTypes.object.isRequired,
  lead: PropTypes.object.isRequired,
  submitLinkCta: PropTypes.func.isRequired,
  onDone: PropTypes.func.isRequired
}

function mapStateToProps({lead}) {
  return {lead}
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ submitLinkCta }, dispatch)
}

export default withOutboundLink(
  connect(mapStateToProps, mapDispatchToProps)(OpenLinkContainer)
)